var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.skip)?_c('span',[_vm._v("HIDE")]):_c('span',[_vm._t("content",function(){return [_vm._v(_vm._s(_vm.content))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }